// extracted by mini-css-extract-plugin
export default {"wrapper":"jha","container":"kha","image":"lha","info":"mha","title":"nha","note":"oha","product":"pha","product_img":"qha","description":"rha","name":"sha","whybtn":"tha","buttons":"uha"};
    if(module.hot) {
      // 1738836199283
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  